import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  show: false,
  text: 'Loading...',
}

const loadingOverlaySlice = createSlice({
  name: 'loadingOverlay',
  initialState,
  reducers: {
    showLoadingOverlay(state, action) {
      state.show = true
      if (action.payload) {
        state.text = action.payload
      }
    },
    hideLoadingOverlay(state) {
      state.show = false
    },
  },
})

export const { showLoadingOverlay, hideLoadingOverlay } = loadingOverlaySlice.actions

export default loadingOverlaySlice.reducer

export const loadingOverlaySelector = (state) => state.loadingOverlay
